import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function Offers() {
  return <section className="bg-brand-darker py-16 sm:py-24 lg:py-32 px-5 sm:px-6 md:px-12" data-id="element-43">
      <div className="max-w-6xl mx-auto" data-id="element-44">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[28px] sm:text-[36px] font-bold text-brand-cream text-center mb-10 sm:mb-16 leading-tight" data-id="element-45">
          Choisissez votre forfait.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-6 lg:gap-8 mb-10 sm:mb-12" data-id="element-46">
          {/* Card 1 - Signature */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-brand-dark border border-brand-gold rounded-[12px] p-6 sm:p-8 lg:p-10 relative flex flex-col" data-id="element-47">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-black text-[11px] sm:text-[12px] font-bold px-3 sm:px-4 py-1 rounded-full whitespace-nowrap" data-id="element-48">
              ⭐ LE PLUS POPULAIRE
            </div>

            <h3 className="text-[20px] sm:text-[22px] font-bold text-brand-gold mb-5 sm:mb-6 font-serif" data-id="element-49">
              ✦ LinkedIn Signature
            </h3>

            <div className="mb-5 sm:mb-6" data-id="element-50">
              <div className="text-[40px] sm:text-[48px] font-bold text-brand-cream leading-none mb-2 font-serif" data-id="element-51">
                497 $
              </div>
              <div className="text-[13px] text-brand-cream/60 line-through" data-id="element-52">
                Valeur réelle : 900 $+
              </div>
            </div>

            <p className="text-[14px] sm:text-[15px] text-brand-cream/80 italic mb-6 sm:mb-8 min-h-[45px]" data-id="element-53">
              Votre profil existe déjà. Mais il ne travaille pas pour vous. On
              change ça.
            </p>

            <ul className="space-y-3 sm:space-y-4 mb-8 sm:mb-10 flex-grow" data-id="element-54">
              {['Audit complet de votre profil actuel', 'Titre stratégique qui positionne', 'Bannière professionnelle sur mesure', 'Section À propos qui convertit', 'Expérience restructurée et valorisée', 'Section services configurée', 'URL personnalisée', '1 publication de lancement prête à publier', "Mini-guide d'utilisation LinkedIn", 'Appel de remise personnalisé (15 min)'].map((item, i) => <li key={i} className="flex items-start text-[14px] sm:text-[15px] text-brand-cream" data-id="element-55">
                  <Check className="w-5 h-5 text-brand-gold mr-3 shrink-0 mt-0.5" data-id="element-56" />
                  <span data-id="element-57">{item}</span>
                </li>)}
            </ul>

            <div className="text-[13px] text-brand-gold mb-5 sm:mb-6 font-medium" data-id="element-58">
              ⏱ Délai : 3 à 5 jours ouvrables
            </div>

            <a href="https://wa.me/15148095007?text=Bonjour%20Rebeca%2C%20je%20veux%20le%20forfait%20LinkedIn%20Signature%20%C3%A0%20497%24" target="_blank" rel="noopener noreferrer" className="w-full bg-brand-gold text-brand-black font-bold text-[14px] sm:text-[15px] py-4 rounded-[6px] flex items-center justify-center hover:bg-white transition-colors group text-center" data-id="element-59">
              <ArrowRight className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform shrink-0" data-id="element-60" />
              Je veux transformer mon LinkedIn
            </a>
          </motion.div>

          {/* Card 2 - Création */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-dark border border-brand-cream/30 rounded-[12px] p-6 sm:p-8 lg:p-10 flex flex-col mt-2 md:mt-0" data-id="element-61">
            <h3 className="text-[20px] sm:text-[22px] font-bold text-brand-cream mb-5 sm:mb-6 font-serif" data-id="element-62">
              ✦ LinkedIn Création
            </h3>

            <div className="mb-5 sm:mb-6" data-id="element-63">
              <div className="text-[40px] sm:text-[48px] font-bold text-brand-cream leading-none mb-2 font-serif" data-id="element-64">
                297 $
              </div>
              <div className="text-[13px] opacity-0" data-id="element-65">Spacer</div>
            </div>

            <p className="text-[14px] sm:text-[15px] text-brand-cream/80 italic mb-6 sm:mb-8 min-h-[45px]" data-id="element-66">
              Vous n'avez pas encore de profil. Ou il est vide depuis des
              années. On part de zéro — et on fait ça bien.
            </p>

            <ul className="space-y-3 sm:space-y-4 mb-8 sm:mb-10 flex-grow" data-id="element-67">
              {['Création complète du profil', 'Bannière professionnelle sur mesure', 'Titre + bio stratégiques', 'Section services configurée', 'URL personnalisée', '1 publication de lancement prête à publier', "Mini-guide d'utilisation LinkedIn"].map((item, i) => <li key={i} className="flex items-start text-[14px] sm:text-[15px] text-brand-cream" data-id="element-68">
                  <Check className="w-5 h-5 text-brand-gold mr-3 shrink-0 mt-0.5" data-id="element-69" />
                  <span data-id="element-70">{item}</span>
                </li>)}
            </ul>

            <div className="text-[13px] text-brand-gold mb-5 sm:mb-6 font-medium" data-id="element-71">
              ⏱ Délai : 3 à 5 jours ouvrables
            </div>

            <a href="https://wa.me/15148095007?text=Bonjour%20Rebeca%2C%20je%20veux%20le%20forfait%20LinkedIn%20Cr%C3%A9ation%20%C3%A0%20297%24" target="_blank" rel="noopener noreferrer" className="w-full bg-transparent border-2 border-brand-gold text-brand-gold font-bold text-[14px] sm:text-[15px] py-3.5 rounded-[6px] flex items-center justify-center hover:bg-brand-gold hover:text-brand-black transition-colors group text-center" data-id="element-72">
              <ArrowRight className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform shrink-0" data-id="element-73" />
              Je veux créer mon LinkedIn
            </a>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-[14px] text-brand-cream/60 text-center" data-id="element-74">
          Vous ne savez pas lequel vous convient?
          <br className="sm:hidden" data-id="element-75" /> Écrivez-moi — je vous guide en 5 minutes.
          ✦
        </motion.p>
      </div>
    </section>;
}